<template>
  <el-dialog title="账单详情" :visible="dialogVisible" @close="handleClose" width="80%">
    <el-table :data="billData.records" v-loading="loading">
      <el-table-column prop="id" label="账单ID" width="180"></el-table-column>
      <el-table-column prop="saleId" label="预投保单号" width="200"></el-table-column>
      <el-table-column label="金额" align="right" width="150" >
        <template #default="{row}">¥{{ row.amount.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="类型" width="120">
        <template #default="{row}">
          {{ row.refundOrPayStatus === '0' ? '退款' : '支付' }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="创建时间" width="180" prop="createTime"></el-table-column>
    </el-table>

    <!-- 添加分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="billData.total"
      style="margin-top: 15px"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import {service} from '../../../utils/axios'

export default {
  props: {
    saleId: String,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      billData: {
        records: [],
        total: 0
      },
      dialogVisible: this.visible // 本地副本
    }
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.dialogVisible = newVal // 同步父组件变化
        this.fetchData()
      }
    }
  },
  methods: {
    async fetchData () {
      try {
        this.loading = true
        const res = await service.get('/website/lccPaymentTransaction/page', {
          params: {
            saleId: this.saleId,
            pageNo: this.currentPage,
            pageSize: this.pageSize
          }
        })
        if (res.success) {
          this.billData = {
            records: res.result.records,
            total: res.result.total
          }
        }
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleClose () {
      this.dialogVisible = false
      this.$emit('update:visible', false) // 通知父组件更新
    },
    dayjs
  }
}
</script>



// WEBPACK FOOTER //
// src/views/lcc/components/BillDialog.vue